import type { A1EmbedNavConfig } from "@/context/A1EmbedNavigationContext";
import { sd } from "./sdPaths";

export const sdA1EmbedNavConfig: A1EmbedNavConfig = {
  schemas: sd("admin/a1-schemas"),
  schemaAdd: sd("admin/schemas/add"),
  schemaEdit: name => sd(`admin/schemas/edit/${name}`),
  schemaRender: name => sd(`admin/from/${name}`),
  module: name => sd(`admin/module/${encodeURIComponent(name)}`),
  moduleAdd: name => sd(`admin/module/${encodeURIComponent(name)}/add`),
  moduleEdit: (schemaName, id) =>
    sd(
      `admin/module/${encodeURIComponent(schemaName)}/edit/${encodeURIComponent(id)}`
    ),
  print: (schemaName, recordId) =>
    sd(
      `admin/print/${encodeURIComponent(schemaName)}/${encodeURIComponent(recordId)}`
    ),
  imports: sd("admin/a1-imports"),
  importAdd: sd("admin/imports/add"),
  importDetail: id => sd(`admin/imports/${id}`),
  permissions: sd("admin/a1-permission"),
  roles: sd("admin/a1-roles"),
  roleAdd: sd("admin/tenant/roles/add"),
  roleEdit: id => sd(`admin/tenant/roles/edit/${id}`),
  users: sd("admin/a1-tenant-users"),
  userAdd: sd("admin/tenant/users/add"),
  userEdit: id => sd(`admin/tenant/users/edit/${id}`),
  slaConfiguration: sd("admin/sla-configuration"),
  slaConfigurationAdd: sd("admin/sla-configuration-add"),
};
